module.exports = __webpack_public_path__ + "img/menu.73d57590.png";